import { render, staticRenderFns } from "./setting-online-chat.vue?vue&type=template&id=2d54156d&"
import script from "./setting-online-chat.vue?vue&type=script&lang=js&"
export * from "./setting-online-chat.vue?vue&type=script&lang=js&"
import style0 from "./setting-online-chat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports